module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921081151_T.d4cf6b6d.jpg";